<h2 class="pb-[2.5rem]">{{ 'job.title' | transloco }}</h2>
<div
  class="flex flex-col md:flex-row w-full divide-y-2 md:divide-y-0 divide-x-0 md:divide-x-2 divide-vinciBlue-300 rounded-xl bg-white mb-[2.5rem]"
>
  <app-filter-result-section
    [title]="'job.sector' | transloco"
    [filter]="jobStore.branchesFiltersSelected()"
    [filterExists]="jobStore.branchesFilterExists()"
    [textIfNoFilter]="'job.noSectorFilterSelected' | transloco"
  ></app-filter-result-section>
  @if (jobStore.activitiesFiltersSelected() !== null) {
  <app-filter-result-section
    [title]="'job.activity' | transloco"
    [filter]="jobStore.activitiesFiltersSelected()"
    [filterExists]="jobStore.activitiesFilterExists()"
    [textIfNoFilter]="'job.noActivityFilterSelected' | transloco"
  ></app-filter-result-section>
  }
  <app-filter-result-section
    [title]="'job.location' | transloco"
    [filter]="jobStore.locationFiltersSelected()"
    [filterExists]="jobStore.locationFilterExists()"
    [textIfNoFilter]="'job.noLocationFilterSelected' | transloco"
    [extraSelectedFilterTranslations]="[jobStore.locationSearchValueSelected()]"
  ></app-filter-result-section>
</div>
<h2 class="mb-[1.5rem]">{{ 'job.results' | transloco }}</h2>

@if(loading()) {
<div class="my-[6.25rem]"><loader /></div>
} @else { @if (jobStore.anyResults()) {
<p class="!font-bold mb-[2.5rem]">
  {{ jobStore.pagination().total }} {{ jobStore.pagination().total > 1 ?
  ('job.foundManyResults' | transloco) : ('job.foundOneResult' | transloco) }}
</p>
<div class="grid grid-cols-1 sm:grid-cols-2 gap-6 pb-6">
  @for (job of jobStore.results(); track $index) {
  <app-card-result
    [title]="job.title"
    [text]="job.text"
    [image]="job.image"
    [link]="job.link"
    [variant]="$index % 4 === 0 ? 'primary' : $index % 4 === 1 ? 'secondary' : $index % 4 === 2 ? 'tertiary' : 'quaternary'"
    [isAbleToAddToFavorites]="true"
  ></app-card-result>
  }
</div>
} @else {
<p class="text-center">{{ 'job.noResultFound' | transloco }}</p>
} } @if(extraResultLoading()) {
<div class="my-[6.25rem]"><loader /></div>
}

<div class="flex flex-col sm:flex-row justify-end gap-6 pb-[2.5rem]">
  @if (jobStore.pagination() !== null && jobStore.pagination().total >
  jobStore.results().length) {
  <app-button
    [text]="'job.seeMoreJobs' | transloco"
    [variant]="'primary'"
    [disabled]="extraResultLoading()"
    (buttonClick)="loadMoreJobCards()"
  ></app-button>
  }

  <app-button
    [text]="'job.changeFilters' | transloco"
    [variant]="'secondary'"
    [icon]="'back'"
    [iconSize]="'1.5rem'"
    [size]="'sm'"
    [disabled]="extraResultLoading()"
    (buttonClick)="redirectToJobResearch()"
  ></app-button>
</div>

@if(isRequestErrorModalOpen()){
<app-modal
  [title]="'job.errorModalTitle' | transloco"
  [text]="'job.errorModalText' | transloco"
  [buttonText]="'job.errorModalCtaText' | transloco"
  (closeModal)="closeRequestErrorModal()"
  (completeModal)="closeRequestErrorModalAndRedirectToJobResearch()"
></app-modal>
}
